import { Box, Tab, Tabs } from "@mui/material";
import { useBreadcrumb } from "hooks/useBreadcrumbs";
import { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function a11yProps(index: number) {
  return {
    id: `mail-room-tab-${index}`,
    "aria-controls": `mail-room-tabpanel-${index}`,
  };
}

const tabs = [
  {
    label: "Status Checker",
    path: "/staff/mail-room/status",
  },
  {
    label: "Send Mail",
    path: "/staff/mail-room/send",
  },
];

export const Communications = () => {
  useBreadcrumb({ label: "Mail Room", to: "/staff/mail-room/status" });
  const location = useLocation();
  const navigate = useNavigate();

  // Check if we're in details view
  const isDetailsView = location.pathname.includes("/status/");

  // Determine active tab based on current path
  const currentPath = location.pathname.split("/");
  const activeTab = useMemo(() => {
    if (isDetailsView) return 0;
    const current = currentPath.pop() || "status";
    return tabs.findIndex((tab) => tab.path.endsWith(current));
  }, [currentPath, isDetailsView]);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={activeTab !== -1 ? activeTab : 0}
          aria-label="Mail Room tabs"
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab.label}
              label={tab.label}
              onClick={() => navigate(tab.path)}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>
      <Outlet />
    </Box>
  );
};
